import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {BiolinkEditorService} from '../../biolink-editor.service';

export interface CrupdateWidgetDialogData {
    biolinkId: number;
    widgetId?: number;
    config?: {url?: string};
}

@Component({
    selector: 'twitch-widget-modal',
    templateUrl: './twitch-widget-modal.component.html',
    styleUrls: ['./twitch-widget-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TwitchWidgetModalComponent {
    static type = 'twitchEmbed';
    errors$ = new BehaviorSubject<{url?: string}>({});
    form = new FormGroup({
        url: new FormControl(''),
    });

    constructor(
        private dialogRef: MatDialogRef<TwitchWidgetModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CrupdateWidgetDialogData,
        public editor: BiolinkEditorService
    ) {
        if (data.config?.url) {
            this.form.patchValue({url: data.config?.url});
        }
    }

    createOrUpdate() {
        if (!this.form.value.url.includes('twitch.tv/')) {
            return this.errors$.next({url: 'This is not a valid twitch url.'});
        }
        this.editor
            .crupdateWidget(
                this.data.widgetId,
                TwitchWidgetModalComponent.type,
                this.form.value
            )
            .subscribe(response => {
                this.dialogRef.close(response.widget);
            });
    }

    close() {
        this.dialogRef.close();
    }
}
